













import Vue from 'vue'
import { Stay } from 'models/data/stay'
import stays from '@store/stays'
import { nextSteps } from 'utils/text/plan'
import EditModal from '../EditModal.vue'
import EditNextSteps from '@ward/discharge/EditNextSteps.vue'


export default Vue.extend({
    components: {
        EditModal,
        EditNextSteps,
    },
    props: {
        stay_id: {
            type: Number,
            required: true
        }
    },
    computed: {
        stay(): Stay | undefined {
            return stays.state.stays[this.stay_id]
        },
        summaryText(): string[] {
            return nextSteps({ stay: this.stay })
        },
    },
})
